import EventsVue from '../EventsVue.vue'

export const eventsRoute = [
  {
    path: '/events-manager',
    name: 'events-m',
    component: EventsVue
  }
]
